module.exports = __webpack_public_path__ + "img/ewm.1d1ea1a6.png";